import React, { FC } from 'react';
import { Autocomplete, Box, TextField } from '@mui/material';
import { AutocompleteMultipleValuesProps } from './AutocompleteMultipleValuesProps';

const AutocompleteMultipleValues: FC<AutocompleteMultipleValuesProps> = ({
  controllerValue,
  controllerOnChange,
  options,
  formStateErrors,
  controllerName,
  label,
  getOptionLabelPropName,
  renderOptionPropName,
  id,
  disabled,
}) => {
  const filteredOptions = options.filter((option) => {
    if (!controllerValue) return true;
    return !controllerValue.some((selected) =>
      typeof option === 'object' && typeof selected === 'object'
        ? option[getOptionLabelPropName] === selected[getOptionLabelPropName]
        : option === selected,
    );
  });
  return (
    <Autocomplete
      id={id}
      multiple
      value={controllerValue ? controllerValue : []}
      fullWidth
      disablePortal
      disabled={disabled || !options?.length}
      getOptionLabel={(option) => {
        if (typeof option === 'object' && getOptionLabelPropName) {
          return option[getOptionLabelPropName] || '';
        }
        if (typeof option === 'string') {
          return option;
        }
        return '';
      }}
      onChange={(_, value) => {
        let valueToReturn;
        if (!value) {
          valueToReturn = [];
        } else if (value[value.length - 1] === 'All') {
          valueToReturn = ['All'];
        } else if (value[0] === 'All') {
          valueToReturn = [value.pop()];
        } else {
          valueToReturn = value;
        }

        controllerOnChange(valueToReturn);
      }}
      options={filteredOptions}
      renderOption={(props, option) => (
        <Box component="li" {...props}>
          {(renderOptionPropName && option[renderOptionPropName]) || option}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={!!formStateErrors?.[controllerName]}
          helperText={formStateErrors?.[controllerName]?.message}
          disabled={disabled}
        />
      )}
    />
  );
};

export default AutocompleteMultipleValues;
